
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"00614c79-921d-42fd-be12-949df8048343","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h120v120H0z","fill":"none"}}),_c('path',{attrs:{"d":"M65.74 52.78A5.64 5.64 0 0060 46a5.64 5.64 0 00-5.74 6.78l.94 5.65a5.05 5.05 0 004.8 4.06 5.05 5.05 0 004.8-4.07zM64.9 62.8a7 7 0 01-9.81 0l-6.88 2.3A3.46 3.46 0 0046 68.17V74h28v-5.83a3.47 3.47 0 00-2.21-3.07z"}})])
          )
        }
      }
    